<template>
    <div id="dashboard3">
        <div>
            <!-- charts  -->
            <div class="fix-filters space-btw-charts">
                <vx-card>
                    <vs-row>
                        <vs-col vs-xs="6" vs-sm="5" vs-lg="3">
                            <SelectDate :selectedDate.sync="filters.from_date" label="Start Date" />
                            <small class="block text-danger mt-1" v-if="api_errors && api_errors.from_date">
                                {{ api_errors.from_date.join(', ') }}
                            </small>
                        </vs-col>
                        <vs-col vs-xs="6" vs-sm="5" vs-lg="3" class="mobile_to_date">
                            <div class="ml-2">
                                <SelectDate :selectedDate.sync="filters.to_date" label="End Date" />
                            </div>
                            <small class="block text-danger mt-1" v-if="api_errors && api_errors.to_date">
                                {{ api_errors.to_date.join(', ') }}
                            </small>
                        </vs-col>
                    </vs-row>
                </vx-card>
            </div>
            <!-- mobile screen -->
            <div v-if="$store.state.windowWidth <= 767">
                <!-- pie chart start  -->
                <vs-row class="space-btw-charts">
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                        <vx-card class="widget pb-3">
                            <template slot="no-body">
                                <div class="widget--heading" style="display: flex; flex-direction: column;">
                                    <div class="mb-2" style="align-self: start;">
                                        <h5>Pie Chart</h5>
                                    </div>
                                    <div style="width: 100%;">
                                        <vs-row class="mb-2">
                                            <vs-col vs-xs="10">
                                                <InputSelect :model.sync="mobile_pie_chart_filters"
                                                    placeholder="Choose" container_class="w-auto mobile-d3-pie-dropdown-alignment input-custom-dropdown"
                                                    :options="mobile_pie_chart_options" :multiple="false" 
                                                />
                                            </vs-col>
                                        </vs-row>
                                    </div>
                                </div>
                            </template>
                            <div>
                                <PieChart :labels="pie_count_labels" :dataset="mobile_pie_chart_data(mobile_pie_chart_filters)"
                                    :height="280" :labels_background_color="pie_count_background_labels" legend_position="bottom"
                                    legend_font_size="8"
                                />
                            </div>
                        </vx-card>
                    </vs-col>
                </vs-row>
                <!-- bar chart  -->
                <vs-row class="space-btw-charts">
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                        <vx-card class="widget pb-3">
                            <template slot="no-body">
                                <div class="widget--heading" style="display: flex; flex-direction: column;">
                                    <div class="mb-2" style="align-self: start;">
                                        <h5>Bar Chart</h5>
                                    </div>
                                    <div style="width: 100%;">
                                        <vs-row class="mb-2">
                                            <vs-col vs-xs="5" vs-sm="5">
                                                <h6>Module Type</h6>
                                            </vs-col>
                                            <vs-col vs-xs="7" vs-sm="7">
                                                <InputSelect :model.sync="bar_filters.bar_module_type" placeholder="Choose"
                                                    container_class="w-auto input-custom-dropdown" :options="module_type_options" :multiple="false" 
                                                />
                                            </vs-col>
                                        </vs-row>
                                        <template v-if="bar_filters.bar_module_type == 'road_incident'">
                                            <vs-row :key="bar_filters.bar_module_type + 'ri'">
                                                <vs-col vs-xs="5" vs-sm="5">
                                                    <h6>RI Sub Module</h6>
                                                </vs-col>
                                                <vs-col vs-xs="7" vs-sm="7">
                                                    <InputSelect :model.sync="bar_filters.bar_road_incident_sub_type"
                                                        placeholder="Choose" container_class="w-auto input-custom-dropdown"
                                                        :options="road_incident_sub_type_options" :multiple="false" 
                                                    />
                                                </vs-col>
                                            </vs-row>
                                        </template>
                                        <template v-else-if="bar_filters.bar_module_type == 'major_maintenance'">
                                            <vs-row :key="bar_filters.bar_module_type + 'mm'">
                                                <vs-col vs-xs="5" vs-sm="5">
                                                    <h6>MM Sub Module</h6>
                                                </vs-col>
                                                <vs-col vs-xs="7" vs-sm="7">
                                                    <InputSelect :model.sync="bar_filters.bar_major_maintenance_sub_type"
                                                        placeholder="Choose" container_class="w-auto input-custom-dropdown"
                                                        :options="major_maintenance_sub_type_options" :multiple="false"
                                                    />
                                                </vs-col>
                                            </vs-row>
                                        </template>
                                    </div>
                                </div>
                            </template>
                            <BarChart :stacked="true" legend_position="bottom" x_axis_title="Month/Year"
                                y_axis_title="No. of Issues" :labels_mode="bar_labels_mode" :labels="bar_labels"
                                :dataset="bar_data" :height="340" :legend_font_size="8"  
                            />
                        </vx-card>
                    </vs-col>
                </vs-row>
                <!-- line chart  -->
                <vs-row class="space-btw-charts">
                    <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                        <vx-card class="widget">
                            <template slot="no-body">
                                <div class="widget--heading" style="display: flex; flex-direction: column;">
                                    <div class="mb-2" style="align-self: start;">
                                        <h5>Line Chart</h5>
                                    </div>
                                    <div style="width: 100%;">
                                        <vs-row class="mb-2">
                                            <vs-col vs-xs="5" vs-sm="5">
                                                <h6>Module Type</h6>
                                            </vs-col>
                                            <vs-col vs-xs="7" vs-sm="7">
                                                <InputSelect :model.sync="line_filters.line_module_type" placeholder="Choose"
                                                    container_class="w-auto input-custom-dropdown" :options="module_type_options" :multiple="false" 
                                                />
                                            </vs-col>
                                        </vs-row>
                                        <template v-if="line_filters.line_module_type == 'road_incident'">
                                            <vs-row :key="line_filters.line_module_type + 'ri'">
                                                <vs-col vs-xs="5" vs-sm="5">
                                                    <h6>RI Sub Module</h6>
                                                </vs-col>
                                                <vs-col vs-xs="7" vs-sm="7">
                                                    <InputSelect :model.sync="line_filters.line_road_incident_sub_type"
                                                        placeholder="Choose" container_class="w-auto input-custom-dropdown"
                                                        :options="road_incident_sub_type_options" :multiple="false" 
                                                    />
                                                </vs-col>
                                            </vs-row>
                                        </template>
                                        <template v-else-if="line_filters.line_module_type == 'major_maintenance'">
                                            <vs-row :key="line_filters.line_module_type + 'mm'">
                                                <vs-col vs-xs="5" vs-sm="5">
                                                    <h6>MM Sub Module</h6>
                                                </vs-col>
                                                <vs-col vs-xs="7" vs-sm="7">
                                                    <InputSelect :model.sync="line_filters.line_major_maintenance_sub_type"
                                                        placeholder="Choose" container_class="w-auto input-custom-dropdown"
                                                        :options="major_maintenance_sub_type_options" :multiple="false"
                                                    />
                                                </vs-col>
                                            </vs-row>
                                        </template>
                                    </div>
                                </div>
                            </template>
                            <LineChart :labels="line_labels" :dataset="line_data" legend_position="bottom" 
                                :background_color="line_chart_background_color" :height="340" />
                        </vx-card>
                    </vs-col>
                </vs-row>
            </div>
            <div v-else>
                <div style="width: 100%;">
                    <!-- pie chart  -->
                    <vs-row class="space-btw-charts">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            <vx-card class="pr-0 flex-center">
                                <div class="flex mt-3">
                                    <div class="pie-data-card mb-3">
                                        <vx-card class="widget pie-widget-heading">
                                            <template slot="no-body">
                                                <div class="widget--heading" style="justify-content: center;">
                                                    <h6 class="text-center font-bold" style="margin: 4px; font-size: 12px;">Total Accident Free Hrs</h6>
                                                </div>
                                            </template>
                                            <PieChart :labels="pie_count_labels" :dataset="total_accident_free_hrs_data"
                                                :labels_background_color="pie_count_background_labels" :height="200" />
                                        </vx-card>
                                    </div>
                                    <div class="pie-data-card mb-3 ml-2">
                                        <vx-card class="widget pie-widget-heading">
                                            <template slot="no-body">
                                                <div class="widget--heading" style="justify-content: center;">
                                                    <h6 class="text-center font-bold" style="margin: 4px; font-size: 12px;">Active Enroachment Issue</h6>
                                                </div>
                                            </template>
                                            <PieChart :labels="pie_count_labels" :dataset="active_enroachment_issue_data"
                                                :labels_background_color="pie_count_background_labels" :height="200" />
                                        </vx-card>
                                    </div>
                                    <div class="pie-data-card mb-3 ml-2">
                                        <vx-card class="widget pie-widget-heading">
                                            <template slot="no-body">
                                                <div class="widget--heading" style="justify-content: center;">
                                                    <h6 class="text-center font-bold" style="margin: 4px; font-size: 12px;">Total MM Carried Out</h6>
                                                </div>
                                            </template>
                                            <PieChart :labels="pie_count_labels" :dataset="total_mm_carried_out_data"
                                                :labels_background_color="pie_count_background_labels" :height="200" />
                                        </vx-card>
                                    </div>
                                    <div class="pie-data-card mb-3 ml-2">
                                        <vx-card class="widget pie-widget-heading">
                                            <template slot="no-body">
                                                <div class="widget--heading" style="justify-content: center;">
                                                    <h6 class="text-center font-bold" style="margin: 4px; font-size: 12px;">Safety Program Conducted</h6>
                                                </div>
                                            </template>
                                            <PieChart :labels="pie_count_labels" :dataset="safety_program_conducted_data"
                                                :labels_background_color="pie_count_background_labels" :height="200" />
                                        </vx-card>
                                    </div>
                                    <div class="pie-data-card mb-3 ml-2">
                                        <vx-card class="widget pie-widget-heading">
                                            <template slot="no-body">
                                                <div class="widget--heading" style="justify-content: center;">
                                                    <h6 class="text-center font-bold" style="margin: 4px; font-size: 12px;">Spent On Maintenance(lakhs)</h6>
                                                </div>
                                            </template>
                                            <PieChart :labels="pie_count_labels" :dataset="spent_on_maintenance_data"
                                                :labels_background_color="pie_count_background_labels" :height="200" />
                                        </vx-card>
                                    </div>
                                </div>
                                <div class="mt-3 mb-3 d3-pie-legend">
                                    <template v-for="(item, index) in pie_count_labels">
                                        <div class="d3-pie-legend--container mb-4"  :key="index">
                                            <div :style="{ backgroundColor: pie_count_background_labels[index] }">
                                            </div>
                                            <p class="font-bold"> {{ item }}</p>
                                        </div>
                                    </template>
                                </div>
                            </vx-card>
                        </vs-col>
                    </vs-row>
                    <!-- bar chart  -->
                    <vs-row class="space-btw-charts">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            <vx-card class="widget pb-3">
                                <template slot="no-body">
                                    <div class="widget--heading">
                                        <h5 class="text-center">Bar Chart</h5>
                                        <div class="flex right">
                                            <div style="min-width: 210px">
                                                <InputSelect :model.sync="bar_filters.bar_module_type" label="Module Type" placeholder="Choose"
                                                    container_class="w-auto input-custom-dropdown mr-3" :options="module_type_options" :multiple="false" 
                                                />
                                            </div>
                                            <template v-if="bar_filters.bar_module_type == 'road_incident'">
                                                <div :key="bar_filters.bar_module_type + 'ri'">
                                                    <InputSelect :model.sync="bar_filters.bar_road_incident_sub_type" label="Road Incident Sub Type"
                                                        placeholder="Choose" container_class="w-auto input-custom-dropdown"
                                                        :options="road_incident_sub_type_options" :multiple="false" 
                                                    />
                                                </div>
                                            </template>    
                                            <template v-else-if="bar_filters.bar_module_type == 'major_maintenance'">
                                                <div :key="bar_filters.bar_module_type + 'mm'">
                                                    <InputSelect :model.sync="bar_filters.bar_major_maintenance_sub_type" label="Major Maintenance Sub Type"
                                                        placeholder="Choose" container_class="w-auto input-custom-dropdown"
                                                        :options="major_maintenance_sub_type_options" :multiple="false"
                                                    />
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                                <BarChart :stacked="true" legend_position="bottom" x_axis_title="Month/Year"
                                    y_axis_title="No. of Issues" :labels_mode="bar_labels_mode" :labels="bar_labels"
                                    :dataset="bar_data" :height="340" />
                            </vx-card>
                        </vs-col>
                    </vs-row>
                    <!-- line chart  -->
                    <vs-row class="space-btw-charts">
                        <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
                            <vx-card class="widget">
                                <template slot="no-body">
                                    <div class="widget--heading">
                                        <h5 class="text-center">Line Chart</h5>
                                        <div class="flex right">
                                            <div style="min-width: 210px">
                                                <InputSelect :model.sync="line_filters.line_module_type" label="Module Type" placeholder="Choose"
                                                    container_class="w-auto input-custom-dropdown mr-3" :options="module_type_options" :multiple="false" 
                                                />
                                            </div>
                                            <template v-if="line_filters.line_module_type == 'road_incident'">
                                                <div :key="line_filters.line_module_type + 'ri'">
                                                    <InputSelect :model.sync="line_filters.line_road_incident_sub_type" label="Road Incident Sub Type"
                                                        placeholder="Choose" container_class="w-auto input-custom-dropdown"
                                                        :options="road_incident_sub_type_options" :multiple="false" 
                                                    />
                                                </div>
                                            </template>    
                                            <template v-else-if="line_filters.line_module_type == 'major_maintenance'">
                                                <div :key="line_filters.line_module_type + 'mm'">
                                                    <InputSelect :model.sync="line_filters.line_major_maintenance_sub_type" label="Major Maintenance Sub Type"
                                                        placeholder="Choose" container_class="w-auto input-custom-dropdown"
                                                        :options="major_maintenance_sub_type_options" :multiple="false"
                                                    />
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                                <LineChart :labels="line_labels" :dataset="line_data" legend_position="bottom" 
                                  :background_color="line_chart_background_color" :height="340" />
                            </vx-card>
                        </vs-col>
                    </vs-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SelectDate from '../components/letstream/ls-select-date/SelectDate.vue'
import moment from 'moment'
import { Request } from '../utils/requests'
import BarChart from '../views/charts/BarChart.vue'
import PieChart from './charts/PieChart.vue'
import MapChart from './charts/MapChart.vue'
import MapPopup from './charts/MapPopup.vue'
import LineChart from './charts/LineChart.vue'

export default {
    components: {
        BarChart,
        PieChart,
        SelectDate,
        MapChart,
        MapPopup,
        LineChart
    },
    data() {
        let now = new Date();
        let current_year = now.getFullYear();

        return {

            api_errors: {},

            filters: {
                from_date: moment(new Date(`${current_year}-01-01`)).format('YYYY-MM-DD'),
                to_date: moment(now).format('YYYY-MM-DD'),
            },

            module_type_options: [
                { value: 'routine_maintenance', label: 'Routine Maintenance' },
                { value: 'electrical_maintenance', label: 'Electrical Maintenance' },
                { value: 'major_maintenance', label: 'Major Maintenance' },
                { value: 'highway', label: 'Corrective Maintenance' },
                { value: 'road_incident', label: 'Road Incident' },
                { value: 'enroachment_row', label: 'Enroachment Row' },
                { value: 'safety_program', label: 'Safety Program' },
            ],

            road_incident_sub_type_options: [
                { value: 'road_user_accident', label: 'Road User Accident' },
                { value: 'occupational', label: 'Occupational' },
                { value: 'hazard', label: 'Hazard' },
                { value: 'dead_animal_debris_removal', label: 'Dead Animal Debris Removal' },
                { value: 'vehicle_breakdown', label: 'Vehicle Breakdown' },
                { value: 'traffic_violation', label: 'Traffic Violation' },
                { value: 'unauthorised_parking', label: 'Unauthorised Parking' },
                { value: 'unauthorised_access', label: 'Unauthorised Access' },
                { value: 'unauthorised_media_cut', label: 'Unauthorised Median Cut' },
                { value: 'material_damage', label: 'Material Damage' },
                { value: 'other', label: 'Other' },
            ],

            major_maintenance_sub_type_options: [
                { value: 'main_issue', label: 'Main Issue' },
                { value: 'mm_bituminous_concrete_overlay', label: 'Bituminous Concrete Overlay' },
                { value: 'mm_dense_bituminous_concrete_overlay', label: 'Dense Bituminous Concrete Overlay' },
                { value: 'mm_milling', label: 'Milling' },
                { value: 'mm_thermoplastic_road_marking', label: 'Thermoplastic RoadMarking' },
                { value: 'mm_shoulder_raising', label: 'Shoulder Raising' },
                { value: 'mm_road_sruds_fixing', label: 'RoadSruds Fixing' },
                { value: 'mm_kerb_topping', label: 'Kerb Topping' },
                { value: 'mm_kerb_painting', label: 'Kerb Painting/Crash Barrier' },
                { value: 'mm_microsurfacing', label: 'Micro Surfacing' },
                { value: 'mm_tack_coat', label: 'Tack Coat' },
            ],

            mobile_pie_chart_options: [
                { value: 'total_accident_free_hrs', label: 'Total Accident Free Hrs' },
                { value: 'active_enroachment_issue', label: 'Active Enroachment Issue' },
                { value: 'total_mm_carried_out', label: 'Total MM Carried Out' },
                { value: 'safety_program_conducted', label: 'Safety Program Conducted' },
                { value: 'spent_on_maintenance', label: 'Spent on Maintenance(L)' },
            ],

            mobile_pie_chart_filters: 'total_accident_free_hrs',

            // pie count
            pie_count_labels: [],
            pie_count_background_labels: [],

            total_accident_free_hrs_data: [],
            total_mm_carried_out_data: [],
            active_enroachment_issue_data: [],
            safety_program_conducted_data: [],
            spent_on_maintenance_data: [],

            //bar data
            bar_data: {},
            bar_labels: [],
            bar_labels_mode: {},
            bar_filters: {
                bar_module_type: null,
                bar_major_maintenance_sub_type: null,
                bar_road_incident_sub_type: null,
            },

            // line data
            line_chart_background_color: {},
            line_labels: [],
            line_data: {},
            line_filters: {
                line_module_type: null,
                line_major_maintenance_sub_type: null,
                line_road_incident_sub_type: null,
            },

        }
    },
    watch: {
        filters: {
            deep: true,
            handler(newV) {
                this.load_data();
            }
        },
        bar_filters: {
            deep: true,
            handler() {
                if (!this.validating_filters()) { 
                    this.load_bar_data()
                }
            }
        },
        line_filters: {
            deep: true,
            handler() {
                this.load_line_data()
            }
        }
    },
    mounted() {
        if(window.innerWidth >= 1200) {
            this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', true)
            this.$store.commit('TOGGLE_REDUCE_BUTTON', true)
            this.$store.dispatch('updateSidebarWidth', 'reduced')
        }
        if (this.$store.state.is_online) {
            this.load_data()
            this.load_line_data()
        }
    },
    beforeDestroy(){
        if(window.innerWidth >= 1200) {
            this.$store.commit('UPDATE_SIDEBAR_ITEMS_MIN', false)
            this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
            this.$store.dispatch('updateSidebarWidth', 'default')
        }
    },
    methods: {
        validating_filters() {
            if (!this.filters.from_date) {
                this.api_errors = {
                    "from_date": [
                        "Date from is required.",
                    ]
                }
                return true
            }
            if (!this.filters.to_date) {
                this.api_errors = {
                    "to_date": [
                        "Date to is required.",
                    ]
                }
                return true
            }

            if (this.filters.from_date > this.filters.to_date) {
                this.api_errors = {
                    "from_date": [
                        "should be less than to date.",
                    ]
                }
                return true
            }

            return false
        },
        load_data() {
            if (!this.validating_filters()) {
                this.load_pie_data()
                this.load_bar_data()
            }
        },
        // pie data
        load_pie_data() {

            let url = this.$store.state.apiendpoints.admin_dashboard_stats_view3

            let payload = {
                'metric_type': 'pie_count',
            }

            payload['from_date'] = this.filters.from_date
            payload['to_date'] = this.filters.to_date

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.prepare_pie_data(res.admin_chart_data.pie_count)
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading charts. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        prepare_pie_data(data) {
            // first resetting data then adding
            this.reset_pie_data()

            this.pie_count_labels = data.labels
            this.generatePieColors(this.pie_count_labels)

            for (let i = 0; i < this.pie_count_labels.length; i++) {
                this.total_accident_free_hrs_data.push(data.total_accident_free_hrs[this.pie_count_labels[i]]);
                this.total_mm_carried_out_data.push(data.total_mm_carried_out[this.pie_count_labels[i]]);
                this.active_enroachment_issue_data.push(data.active_enroachment_issue[this.pie_count_labels[i]]);
                this.safety_program_conducted_data.push(data.safety_program_conducted[this.pie_count_labels[i]]);
                this.spent_on_maintenance_data.push(data.spent_on_maintenance[this.pie_count_labels[i]]);
            }

            // to make spent on maintenance in multiple of lakhs 
            for (let i=0; i< this.spent_on_maintenance_data.length; i++) {
                this.spent_on_maintenance_data[i] = parseFloat(((this.spent_on_maintenance_data[i])/100000).toFixed(1))
            }
        },
        reset_pie_data() {
            this.pie_count_background_labels = []
            this.pie_count_labels = []
            this.total_accident_free_hrs_data = []
            this.total_mm_carried_out_data = []
            this.active_enroachment_issue_data = []
            this.safety_program_conducted_data = []
            this.spent_on_maintenance_data = []
        },
        // bar data
        load_bar_data() {

            let url = this.$store.state.apiendpoints.admin_dashboard_stats_view3

            let payload = {
                'metric_type': 'bar_count',
            }

            payload['from_date'] = this.filters.from_date
            payload['to_date'] = this.filters.to_date

            if (this.bar_filters.bar_module_type) {
                payload['bar_module_type'] = this.bar_filters.bar_module_type
            }

            if (this.bar_filters.bar_major_maintenance_sub_type) {
                payload['bar_major_maintenance_sub_type'] = this.bar_filters.bar_major_maintenance_sub_type
            }

            if (this.bar_filters.bar_road_incident_sub_type) {
                payload['bar_road_incident_sub_type'] = this.bar_filters.bar_road_incident_sub_type
            }

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.prepare_bar_data(res.admin_chart_data.bar_count)
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading charts. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        prepare_bar_data(data) {

            this.bar_data = {}
            this.bar_labels = []
            this.bar_labels_mode = {}

            this.bar_labels = data.labels
            this.bar_data = data
            delete this.bar_data.labels

            let organisation_labels = Object.keys(this.bar_data)

            for (let i = 0; i < organisation_labels.length; i++) {
                this.bar_labels_mode[organisation_labels[i]] = organisation_labels[i]
            }
        },
        // line data
        load_line_data() {

            let url = this.$store.state.apiendpoints.admin_dashboard_stats_view3

            let payload = {
                'metric_type': 'line_count',
            }

            if (this.line_filters.line_module_type) {
                payload['line_module_type'] = this.line_filters.line_module_type
            }

            if (this.line_filters.line_major_maintenance_sub_type) {
                payload['line_major_maintenance_sub_type'] = this.line_filters.line_major_maintenance_sub_type
            }

            if (this.line_filters.line_road_incident_sub_type) {
                payload['line_road_incident_sub_type'] = this.line_filters.line_road_incident_sub_type
            }

            Request(this, 'GET', url, payload).then(
                (res) => {
                    this.set_line_chart_background_color(Object.keys(res.admin_chart_data.line_count.dataset))
                    this.line_labels = res.admin_chart_data.line_count.labels
                    this.line_data = res.admin_chart_data.line_count.dataset
                    this.api_errors = {}
                },
                (err) => {
                    if (err.error) {
                        this.api_errors = err.error
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: (err.error && err.error.__non_field_errors__) ? err.error.__non_field_errors__.join(',') : 'An Error Occured. Please Try Again',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    } else {
                        this.$vs.notify({
                            time: 2500,
                            title: 'Error',
                            text: "Server error occured while loading charts. Please try again later.",
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'danger'
                        })
                    }
                }
            )
        },
        generatePieColors(data) {

            for (let i = 0; i < data.length; i++) {
                const color = 'rgba(' + this.getRandomValue() + ', ' + this.getRandomValue() + ', ' + this.getRandomValue() + ', 0.8)';
                this.pie_count_background_labels.push(color);
            }
        },
        // Function to generate a random color value (0-255)
        getRandomValue() {
            return Math.floor(Math.random() * 256);
        },
        set_line_chart_background_color(years) {
            this.line_chart_background_color[years[0]] = '#E2989F'
            this.line_chart_background_color[years[1]] = '#F0A983'
        },
        mobile_pie_chart_data(val) {
            console.log(val)
            if (val == 'total_accident_free_hrs') {
                return this.total_accident_free_hrs_data
            } else if (val == 'active_enroachment_issue') {
                return this.active_enroachment_issue_data
            } else if (val == 'total_mm_carried_out') {
                return this.total_mm_carried_out_data
            } else if (val == 'safety_program_conducted') {
                return this.safety_program_conducted_data
            } else if (val == 'spent_on_maintenance') {
                return this.spent_on_maintenance_data
            } else {
                return []
            }
        },
    }
}
</script>

<style lang="scss">
@mixin mobile {
    @media only screen and (max-width: 768px) {
        @content;
    }
}

#dashboard3 {
  
    @include mobile {
        .space-btw-charts {
            margin-bottom: 3vh !important;
        }

        .vs-col {
            padding: 0px !important;
        }

        .widget--heading {
            .input-custom-dropdown .vs__dropdown-toggle {
                background-color: white;
            }
        }

        .vs--single .vs__selected {
            overflow: hidden !important;
            max-width: 28vw !important;
            white-space: nowrap !important;
        }

        .mobile-d3-pie-dropdown-alignment {
            .vs--single .vs__selected {
                max-width: 48vw !important;
            }
        }

        .mobile_to_date {
            .vdp-datepicker__calendar {
                margin-left: -40vw
        }
    }
    }
}

.vs--single .vs__selected {
  overflow: hidden !important;
  max-width: 22.8ch !important;
  white-space: nowrap !important;
}

.vs-tabs--ul {
  box-shadow: none;
}

.vs-tabs-primary .line-vs-tabs {
  box-shadow: none !important;
}

.vs-tabs--content {
  padding: 2px 10px !important;
}

.custombox .vs-con-loading__container {
  width: 78% !important;
  margin: 0 auto !important;
}

.widget {
  border-radius: 12px;

  .vx-card__header {
    padding-top: 0;
  }

  &--heading {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    padding: 10px 10px;
    display: flex;
    align-items: center;
    background-color: #CDCDCD;

    h5 {
      display: inline-flex;
      margin: 0;
      flex-grow: 1;
    }

    .right {
      .input-custom-dropdown .vs__dropdown-toggle {
        min-width: 170px;
        background-color: white;
      }
    }
  }
}

.widget.pie-widget-heading {
    .widget--heading {
        min-height: 9vh;
    }
}

.pie-data-card {
  width: 19.5% !important;
}

.d3-pie-legend {
    display: flex; 
    justify-content: center; 
    align-items: center; 
    flex-wrap: wrap;

    &--container {
        display: flex; 
        justify-content: center; 
        align-items: center;
        margin-right: 6px;
        margin-bottom: 6px;

        div {
            width: 12px;
            height: 12px;
            border-radius: 4px;
            margin-right: 2px;
        }

        p {
            font-size: 9px;
            font-weight: 600;
        }
    }
}

.space-btw-charts {
    margin-bottom: 5vh;
}
</style>
<style type="text/css" media="screen, projection">
@import url(https://s3.amazonaws.com/assets.freshdesk.com/widget/freshwidget.css);
</style>